export default "__VITE_ASSET__D$qLgb1X__"